import { useState } from 'react';
import { t } from 'i18next';
import { CommentModel, CommentsService } from 'core/services';
import type { DocumentId } from 'core/types';
import { Button, Col, Form, withFroalaEditorHoc } from 'core/components';

type CommentsProps = {
  docType: string;
  docId: DocumentId;
  callback: () => void;
};

const FroalaEditor = withFroalaEditorHoc({ toolbarInline: true });

export function Comments({ docType, docId, callback }: CommentsProps) {
  const [newComment, setNewComment] = useState<CommentModel>(new CommentModel());
  const commentsService = new CommentsService();

  const onNewCommentChange = (comment: unknown) => {
    const com = new CommentModel();
    com.text = comment as string;
    setNewComment(com);
  };

  const onSaveComment = async () => {
    newComment.link = {
      entityID: docId,
      entityType: docType,
    };

    await commentsService.create(newComment);

    setNewComment(prevComment => ({ ...prevComment, text: '' }));
    callback();
  };

  return (
    <Col>
      <Form.Item>
        <FroalaEditor value={newComment.text} onChange={onNewCommentChange} />
      </Form.Item>
      <Form.Item>
        <Button disabled={!newComment.text} onClick={onSaveComment}>
          {t('IssueTracker.Comment')}
        </Button>
      </Form.Item>
    </Col>
  );
}
